module.exports = __webpack_public_path__ + "static/media/footer_bg.b239e81f.jpg";